import { render } from "./SliderInput.vue?vue&type=template&id=227c3847&scoped=true"
import script from "./SliderInput.vue?vue&type=script&lang=js"
export * from "./SliderInput.vue?vue&type=script&lang=js"

import "./SliderInput.vue?vue&type=style&index=0&id=227c3847&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227c3847"]])

export default __exports__